<template>
  <a-form :form="form" @submit.prevent="onSubmit" layout="vertical">
    <a-form-item v-bind="errorsBind('non_field_errors')" />
    <a-row :gutter="16">
      <a-col :span="12">
        <a-form-item
          label="Stare haslo"
          v-bind="errorsBind('current_password')"
          required
        >
          <a-input type="password" v-model="form.current_password" />
        </a-form-item>
      </a-col>
      <a-col :span="12">
        <a-form-item
          label="Nowe hasło"
          v-bind="errorsBind('new_password')"
          required
        >
          <a-input type="password" v-model="form.new_password" />
        </a-form-item>
      </a-col>
      <a-col :span="24">
        <a-button html-type="submit" class="save-button" type="primary"
          >Zapisz hasło</a-button
        >
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import FieldHelper from '@/components/common/forms/FieldsHelper'

export default {
  extends: FieldHelper
}
</script>

<style lang="scss" scoped>
.save-button {
  margin-top: 4px;
}
</style>
